import { queryOptions } from '@tanstack/react-query';
import { api, unwrap, type Schemas } from '@/lib/api/client';

export type Quality = Schemas['ExtractionQualityDto'];
export type SourceQuality = Schemas['SourceQualityDto'];
export type Figures = Schemas['QualityFiguresDto'];
export type FieldFigure = Schemas['FieldFigureDto'];
export type Bucket = Schemas['CalibrationBucketDto'];
export type Calibration = Schemas['CalibrationVerdictDto'];
export type Side = Schemas['CalibrationSideDto'];

export const qualityKeys = {
  all: ['quality'] as const,
  read: (days: number, sourceId?: string) => [...qualityKeys.all, days, sourceId ?? null] as const,
};

/** Extraction quality over the last `days` × 24 h, for every source or just one. Every figure is the API's. */
export const qualityQuery = (days: number, sourceId?: string) =>
  queryOptions({
    queryKey: qualityKeys.read(days, sourceId),
    queryFn: () =>
      unwrap(api.GET('/api/scraping/quality', { params: { query: { days, sourceId } } })),
  });
